import { Box } from '@mui/material';
import { type FC } from 'react';
import { Icon, Text } from '@/components/ui';

interface MenuButtonProps {
  iconSrc: string;
  activeIcon: string;
  text: string;
  active?: boolean;
  iconMargin?: string;
  handleClick?: () => void;
}

export const MenuButton: FC<MenuButtonProps> = ({
  iconSrc,
  text,
  active,
  iconMargin,
  activeIcon,
  handleClick,
}) => {
  return (
    <Box
      onClick={handleClick}
      sx={{
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
        flexDirection: 'column',
        minWidth: '3.875rem',
        cursor: 'pointer',
      }}
    >
      <Box
        sx={{
          textAlign: 'center',
          height: '1.5rem',
          width: '1.5rem',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        {active ? (
          <Icon
            sx={{
              margin: iconMargin || '0',
              height: '100%',
              width: '100%',
            }}
            src={activeIcon}
          />
        ) : (
          <Icon
            sx={{
              margin: iconMargin || '0',
              height: '100%',
              width: '100%',
            }}
            src={iconSrc}
          />
        )}
      </Box>
      <Box
        sx={{
          textAlign: 'center',
          marginTop: '0.3125rem',
          height: '1rem',
          // visibility: active ? 'visible' : 'hidden',
        }}
      >
        <Text sx={{ color: '#9DB2CE', fontSize: '0.75rem' }}>{text}</Text>
      </Box>
    </Box>
  );
};
